import React, { useEffect, useState } from "react";
import Layout from "../Layout";
import Contract from "../../components/mytickets/FormAddMyTicket";
import ItemProductList from "../../components/mytickets/ItemProductList";
import TicketProductList from "../../components/mytickets/TicketProductList";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../../features/authSlice";

const AddMyTicket = () => {
  const [show, setShow] = useState(true);
  const [cart, setCart] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);
  
  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
  }, [isError, navigate]);

  const handleClick = (item) => {
    if (cart.indexOf(item) !== -1) return;
    if (cart.length > 0){
        alert("Sorry One ticket one product, please create a new ticket if you want add your other product issues");
        return
    }
    setCart([...cart, item]);
    setShow(false);
  };

  const handleChange = (item, d) => {
    const ind = cart.indexOf(item);
    const arr = cart;
    arr[ind].amount += d;

    if (arr[ind].amount === 0) arr[ind].amount = 1;
    setCart([...arr]);
  };
  return (
    <Layout>
      <Contract setShow={setShow} size={cart.length} />
      {show ? (
        <ItemProductList handleClick={handleClick} />
      ) : (
        <TicketProductList cart={cart} setCart={setCart} handleChange={handleChange} />
      )}
    </Layout>
  );
};

export default AddMyTicket;
